import * as React from 'react';
import StatisticsVideoArea from "./Components/StatisticsVideoArea";
import GuiHeader from './Components/GuiHeader';

const ATPLayout = ( props: { serverTime: string, matchid: number } ) => {
    return (
        <div className="defaultGuiWrapper atplayout">
            <GuiHeader serverTime={props.serverTime} matchid={props.matchid} showStatsControls={true} />
            <div className="sr-grid guiContent">
                <div className="sr-cell sr-xs-1-1 sr-l-2-3 sr-xl-1-3-4 videoWrapper">
                    <div className="sr-content sr-align-center">
                        <div className="videoContent sr-content">
                            <StatisticsVideoArea showPlayerProfiles={false}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ATPLayout;
